"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.banking_reconciliation = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var banking_reconciliation = function banking_reconciliation(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'banking_reconciliation-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M4 2.25C3.0335 2.25 2.25 3.0335 2.25 4V13C2.25 13.9665 3.0335 14.75 4 14.75H5.25V16C5.25 16.9665 6.0335 17.75 7 17.75H16C16.9665 17.75 17.75 16.9665 17.75 16V7C17.75 6.0335 16.9665 5.25 16 5.25H14.75V4C14.75 3.0335 13.9665 2.25 13 2.25H4ZM13.25 5.25V4C13.25 3.86193 13.1381 3.75 13 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V13C3.75 13.1381 3.86193 13.25 4 13.25H5.25V6C5.25 5.58579 5.58579 5.25 6 5.25H13.25ZM6.75 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14V6.75H16C16.1381 6.75 16.25 6.86193 16.25 7V16C16.25 16.1381 16.1381 16.25 16 16.25H7C6.86193 16.25 6.75 16.1381 6.75 16V14.75ZM12.5303 9.03033C12.8232 8.73744 12.8232 8.26256 12.5303 7.96967C12.2374 7.67678 11.7626 7.67678 11.4697 7.96967L9.5 9.93934L9.03033 9.46967C8.73744 9.17678 8.26256 9.17678 7.96967 9.46967C7.67678 9.76256 7.67678 10.2374 7.96967 10.5303L8.96967 11.5303C9.26256 11.8232 9.73744 11.8232 10.0303 11.5303L12.5303 9.03033Z',
    fill: '#4B5563'
  }));
};

exports.banking_reconciliation = banking_reconciliation;